import * as $ from 'jquery';

import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { AttrFilterWidget as mainModule } from './main';

import * as Config from './config';
import { init as mainTheme } from './themes/main';

declare var require: any;
require('../sass-main/pdc-widget-filter-attributes.sass');

export class AttrFilterWidget extends WidgetBase {
    public static _name: string = Config.name;
    public static group = Config.group;
    public static moduleName: string = Config.moduleName;
    public static icon: string = Config.icon;
    public static namespace: string = Config.namespace;
    public static priority: number = Config.priority;

    public static themeModule = mainTheme;

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-filter-attributes'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob = {}
    ) {
        values['themeNodeIdToExpand'] = Config.themeId; //VR: WI80078
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(AttrFilterWidget);
